function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 1.5a1.5 1.5 0 00-3 0V18H1.5a1.5 1.5 0 000 3H18v16.5a1.5 1.5 0 003 0V21h16.5a1.5 1.5 0 000-3H21V1.5z",
  fill: "#333"
});

function SvgCatalogCashAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAzOSAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMSAxLjVDMjEgMC42NzE1NzMgMjAuMzI4NCAwIDE5LjUgMEMxOC42NzE2IDAgMTggMC42NzE1NzMgMTggMS41VjE4SDEuNUMwLjY3MTU3MiAxOCAwIDE4LjY3MTYgMCAxOS41QzAgMjAuMzI4NCAwLjY3MTU3MiAyMSAxLjUgMjFIMThWMzcuNUMxOCAzOC4zMjg0IDE4LjY3MTYgMzkgMTkuNSAzOUMyMC4zMjg0IDM5IDIxIDM4LjMyODQgMjEgMzcuNVYyMUgzNy41QzM4LjMyODQgMjEgMzkgMjAuMzI4NCAzOSAxOS41QzM5IDE4LjY3MTYgMzguMzI4NCAxOCAzNy41IDE4SDIxVjEuNVoiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+";
export { SvgCatalogCashAdd as ReactComponent };